import * as React from 'react';
import type { SVGProps } from 'react';

const SvgProfileButton = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={6} height={10} fill="none" {...props}>
    <path
      fill="#F32A52"
      d="M.435.22a.767.767 0 0 0-.212.532c0 .199.076.39.212.531l3.582 3.722-3.582 3.72a.768.768 0 0 0-.204.53.767.767 0 0 0 .212.525.71.71 0 0 0 .506.22.71.71 0 0 0 .509-.211l4.094-4.253a.767.767 0 0 0 .212-.531c0-.2-.077-.391-.212-.532L1.458.22A.71.71 0 0 0 .946 0a.71.71 0 0 0-.511.22Z"
    />
  </svg>
);
export default SvgProfileButton;
